import { render, staticRenderFns } from "./signDocument.vue?vue&type=template&id=a550885a&scoped=true&"
import script from "./signDocument.vue?vue&type=script&lang=js&"
export * from "./signDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550885a",
  null
  
)

export default component.exports